import { Flag, BookOpen, Rocket, Users, Megaphone, PiggyBank, ShieldAlert, CalendarClock, Lightbulb } from "lucide-react";

export const WR_STATUSES = ["Draft", "Ready for review", "Reviewed", "Finalised"];
export const WR_OWNERS = ["Steven", "Richard", "Both"];
export const WR_PRIORITIES = ["Low", "Medium", "High", "Critical"];
export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const wrStatusBadge = (s) =>
  ({ Draft: "neutral", "Ready for review": "warning", Reviewed: "info", Finalised: "success" }[s] || "neutral");

// section metadata drives both the detail view and the printable view
export const WR_SECTIONS = [
  { key: "priorities", label: "Priorities & Delivery", icon: Flag, accent: "#1D4ED8" },
  { key: "product", label: "Product & Content", icon: BookOpen, accent: "#7C3AED" },
  { key: "launch", label: "Launch", icon: Rocket, accent: "#F97316" },
  { key: "investors", label: "Investors", icon: Users, accent: "#0EA5A4" },
  { key: "marketing", label: "Marketing & Growth", icon: Megaphone, accent: "#EC4899" },
  { key: "finance", label: "Finance & Runway", icon: PiggyBank, accent: "#16A34A" },
  { key: "decisions_risks", label: "Decisions & Risks", icon: ShieldAlert, accent: "#DC2626" },
  { key: "office", label: "Office Schedule", icon: CalendarClock, accent: "#0EA5A4" },
  { key: "innovations", label: "Future Innovations", icon: Lightbulb, accent: "#E0A82E" },
];

export const wrSectionLabel = (key) => (WR_SECTIONS.find((s) => s.key === key) || {}).label || key;

// ---------- date helpers (local, no TZ surprises) ----------
const pad = (n) => String(n).padStart(2, "0");
const isoOf = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const todayIso = () => isoOf(new Date());
const parseIso = (iso) => new Date(`${String(iso).slice(0, 10)}T00:00:00`);
export const mondayOf = (iso) => { const d = parseIso(iso); const off = (d.getDay() + 6) % 7; d.setDate(d.getDate() - off); return isoOf(d); };
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const fmtDate = (iso) => (iso ? `${parseIso(iso).getDate()} ${MON[parseIso(iso).getMonth()]} ${parseIso(iso).getFullYear()}` : "—");
export const fmtShort = (iso) => (iso ? `${parseIso(iso).getDate()} ${MON[parseIso(iso).getMonth()]}` : "—");
export const weekRange = (ws, we) => {
  if (!ws) return "—";
  const a = parseIso(ws), b = parseIso(we || ws);
  const same = a.getMonth() === b.getMonth();
  return same
    ? `${a.getDate()}–${b.getDate()} ${MON[a.getMonth()]} ${a.getFullYear()}`
    : `${a.getDate()} ${MON[a.getMonth()]} – ${b.getDate()} ${MON[b.getMonth()]} ${b.getFullYear()}`;
};
export const gbp = (n) => (n == null ? "—" : `£${Math.round(Number(n)).toLocaleString("en-GB")}`);
export const readinessTrend = (change) => {
  if (change == null) return { label: "No prior review", dir: null, color: "#5A6B8C" };
  if (change > 0) return { label: `+${change}% since last review`, dir: "up", color: "#16A34A" };
  if (change < 0) return { label: `${change}% since last review`, dir: "down", color: "#DC2626" };
  return { label: "No change since last review", dir: "flat", color: "#5A6B8C" };
};
